import { render, staticRenderFns } from "./TutoringItem.vue?vue&type=template&id=e537b5fe&scoped=true"
import script from "./TutoringItem.vue?vue&type=script&lang=js"
export * from "./TutoringItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e537b5fe",
  null
  
)

export default component.exports